import { getCarouselArrayTransformed } from '../../transformers/carousel-array-transformer';
import { carouselConfigJson } from '../../mocks/carousel-config-mock';

const configJson = carouselConfigJson.playlistConfig;

export const getCarouselData = async (baseUrl, tabData = configJson, hlPrevTags) => {
  const assetsList = await getCarouselArrayTransformed(tabData, baseUrl, hlPrevTags);
  return assetsList;
};
